<template>
  <div id="app">
      <router-view  v-if="isRouterAlive"/>
  </div>
</template>


<script>
//import AppNavigatorVue from './components/AppNavigator.vue';

import router from "./router";

export default ({
  name: "LayOut",
  components: {
    //AppNavigatorVue
  },
    provide() { // 父组件中返回要传给下级的数据
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRouterAlive: true
        }
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function() {
                this.isRouterAlive = true
            })
        },
    },
    mounted() {
      let v = this;
      window.addEventListener("resize", function () {
        v.reload();
      })
        console.log(location)
    },
    watch: {
        $route:{
            handler(to,from){

            }
        }
    },
  setup() {
    //AppNavigatorVue
  },
})
</script>

<style>
*{
  margin: 0px;
  padding: 0px;
  border: 0px;
  box-sizing: inherit;
}
    body{
        font-size: 14px;
    }
</style>
